import React, { useState } from "react";
import "../static/css/AdminControl.css";

function AdminControlPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newAdmin = {
      username: name,
      emailid: email,
      password,
    };

    try {
      const response = await fetch("https://skpbackend.quindl.com/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newAdmin),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("New admin created:", result);
      } else {
        const errorText = await response.text();
        setErrorMessage(errorText);
      }
    } catch (error) {
      console.error("Error adding admin:", error);
      setErrorMessage("An error occurred while adding admin.");
    }
  };

  return (
    <>
      <div className="Admincontrol">
        <div className="admincontrol-form">
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />

            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />

            <button type="submit">Add New Admin</button>
          </form>
          {errorMessage && <p className="error-message">{errorMessage}</p>}{" "}
        </div>
      </div>
    </>
  );
}

export default AdminControlPage;
